import { fetchAccessTokenIfNeeded } from '~/AccessToken';
import { findProductPrices, PricesResult } from '~/Api/ProductPrice';
import { findProductPrices as findGroupProductPrices } from '~/Api/User/ProductGroup/ProductPrice';
import { invokeApi, resolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import { Action, ActionType } from './Action';

export function fetchPrices(
	productIds: string[],
	currency: string | null,
	groupId: string | null = null
): ThunkAction<Promise<PricesResult>, Action> {
	return async (dispatch) => {
		const userId = (await dispatch(fetchAccessTokenIfNeeded())).accessToken.user.id;
		const request =
			groupId !== null
				? dispatch(invokeApi(findGroupProductPrices, userId, groupId, currency, productIds))
				: dispatch(invokeApi(findProductPrices, currency, productIds));
		dispatch({
			type: ActionType.request,
			request,
			productIds,
			currency,
			groupId,
		});

		return resolve(request, (response) =>
			dispatch({
				type: ActionType.receive,
				request,
				currency,
				items: response?.items ?? null,
			})
		);
	};
}

export function pruneAllPrices(): Action {
	return { type: ActionType.pruneAll };
}

export function updatePriceTypePreference(
	priceType: string | null,
	filterCalculatedPrice: boolean
): ThunkAction<void, Action> {
	return (_, getState) => {
		const preference = getState().productPrice.priceTypePreference;
		if (priceType === null) {
			preference.save('first-available');
		} else if (priceType === 'ex-factory' && !filterCalculatedPrice) {
			preference.save(null);
		}
	};
}

export function updateHideTooltipPreference(hide: boolean): ThunkAction<void, Action> {
	return (dispatch, getState) => {
		getState().productPrice.hideTooltipPreference.save(hide ? '1' : null);
		dispatch({ type: ActionType.updateHideTooltipPreference });
	};
}
